import {Component, inject} from '@angular/core';
import {ToastComponent} from '@shared/notification/toast.component';
import {NotificationService} from '@shared/notification/notification.service';


@Component({
  selector: 'app-notifications-container',
  styleUrl: './notifications-container.component.scss',
  imports: [
    ToastComponent
  ],
  templateUrl: './notifications-container.component.html'
})
export class NotificationsContainerComponent {

  private readonly notificationService = inject(NotificationService);
  public readonly notifications = this.notificationService.notifications;
}
